// register component(s) with react habitat
import withLazyUnveil from '@src/scripts/hoc/withLazyUnveil';

export default {
	ApplicationForm: withLazyUnveil( {
		loadComponent: () =>
			import(
				/* webpackChunkName: "ApplicationForm" */
				'./index'
			),
		height: 845,
		mobileHeight: 863,
	} ),
};
